import { Dimensions, Image, Text, TouchableOpacity, View,Linking } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import { COLORS, FONTS } from "../../constant";

const isSmallDevice = Dimensions.get('window').width < 767

const useStyles = CreateResponsiveStyle(
    {
        bodyRightViewStyle: {
            backgroundColor: "#ffffff",
            flex: isSmallDevice ? 0.4 : 0.6,
            alignItems: "flex-start",
            flexWrap: "wrap",
            paddingVertical: '6%',
            marginTop: 38,
        },
        rightViewStyle: {
            paddingLeft: "10%",
            display: "flex",
            paddingTop: 45,
        },
        firstForwardViewStyle: {
            display: "flex",
        },
        idfcTextStyle: {
            fontFamily: FONTS.InterThin,
            fontSize: 63,
            color: "#9c1d25",
        },
        keepMvngTextStyle: {
            fontFamily: FONTS.Inter,
            fontSize: 23,
            fontWeight: 300,
            color: "#54565b",
            paddingTop: "2%",
            opacity:0.7,
            marginBottom:30
        },
        qrViewStyle: {
            flexDirection: "row",
            paddingTop: '10%',
            display: "flex"
        },
        imageStyle: {
            resizeMode: "center",
            height: "100%",
            width: "50%",
            alignSelf: "flex-end",
            position: "absolute",
            bottom: -50,
            right: 0,
            aspectRatio: 1.3,
        },
        whatsupTextLink:{
            top:30,
            flexDirection:'row',
            alignItems:'center'
        },
        whatsupText:{
            fontFamily: FONTS.Inter,
            fontSize: 15,
            color: COLORS.warmGrey1,
            paddingLeft:10
        }

    },

    {
        [DEVICE_SIZES.LG]: {
            bodyRightViewStyle: {
                backgroundColor: "#ffffff",
                flex: isSmallDevice ? 0.4 : 0.6,
                alignItems: "flex-start",
                flexWrap: "wrap",
                paddingTop: 0,
                justifyContent: "center",
            },
            rightViewStyle: {
                display: "flex",
            },
            firstForwardViewStyle: {
                display: "flex",
            },
            keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 62,
                fontWeight: "100",
                lineHeight: 66,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: "10%",
            },
            imageStyle: {
                resizeMode: "center",
                height: "100%",
                width: "50%",
                alignSelf: "flex-end",
                position: "absolute",
                bottom: -50,
                right: 0,
                aspectRatio: 1.3,
            },


        },
        [DEVICE_SIZES.MD]: {
            bodyRightViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.5,
                alignItems: "flex-start",
                flexWrap: "wrap",
                paddingTop: 0,
                justifyContent: "flex-start",
                paddingTop: "7%",
                marginTop: 0
            },
            rightViewStyle: {
                display: "flex",
            },
            firstForwardViewStyle: {
                display: "flex",
            },
            idfcTextStyle: {
                fontSize: 55
            },
            whatsupTextLink:{
                display:'none'
            },
            keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 23,
                fontWeight: "200",
                fontStyle: "normal",
                lineHeight: 44,
                letterSpacing: 0,
                textAlign: "left",
                color: "#54565b",
                paddingTop: "6%",
            },
            qrViewStyle: {
                display: "none"
            },
            imageStyle: {
                resizeMode: "center",
                width: "70%",
                alignSelf: "flex-end",
                position: "absolute",
                bottom: -220,
                right: 0,
                zIndex: 99,
                aspectRatio: 1,
            },

        },
        [DEVICE_SIZES.SM]: {
            bodyRightViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.5,
                alignItems: "flex-start",
                flexWrap: "wrap",
                paddingTop: 0,
                justifyContent: "flex-start",
                paddingTop: "7%",
            },
            rightViewStyle: {
                display: "flex",
            },
            firstForwardViewStyle: {
                display: "flex",
            },
            whatsupTextLink:{
                display:'none'
            },
            keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 42,
                fontWeight: "200",
                fontStyle: "normal",
                lineHeight: 44,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: "6%",
            },
            imageStyle: {
                resizeMode: "center",
                width: "70%",
                alignSelf: "flex-end",
                position: "absolute",
                bottom: -30,
                right: 0,
                zIndex: 99,
                aspectRatio: 1,
            },

        },
        [DEVICE_SIZES.XS]: {

            bodyRightViewStyle: {
                backgroundColor: "#f3f3f3",
                flex: 0.55,
                alignItems: "flex-start",
                flexWrap: "wrap",
                paddingTop: 0,
                justifyContent: "flex-start",
            },
            rightViewStyle: {
                display: "none",
            },
            firstForwardViewStyle: {
                display: "none",
            },
            keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 33,
                fontWeight: "200",
                lineHeight: 20,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: "6%",
            },
            imageStyle: {
                height:0
            },
            whatsupTextLink:{
                display:'none'
            },

        },
    }
);
export default useStyles;
